import { render, staticRenderFns } from "./tpl-12.vue?vue&type=template&id=fe2bdb10&scoped=true"
import script from "./tpl-12.vue?vue&type=script&lang=js"
export * from "./tpl-12.vue?vue&type=script&lang=js"
import style0 from "./tpl-12.vue?vue&type=style&index=0&id=fe2bdb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2bdb10",
  null
  
)

export default component.exports